module.exports = __webpack_public_path__ + "img/mr_icon.82b4fa6a.png";